import { ref, onMounted, nextTick, onUnmounted } from "vue";
const scrollIntoView = require("scroll-into-view");

export async function useAnchorEvents() {
    await nextTick();

    const headerHeight = document.getElementsByTagName("header").length > 0 ? document.getElementsByTagName("header")[0].clientHeight : 0;
    const topOffset = headerHeight + 40;

    const scrollOptions = {
        align: {
            top: 0,
            topOffset: topOffset,
        },
    };

    if (window.location.hash) {
        const element = document.getElementById(window.location.hash.substr(1));
        scrollIntoView(element, scrollOptions);
    }

    const scrollElements = document.querySelectorAll("a[href^='#']");

    scrollElements.forEach((element) => {
        if (element.getAttribute("href") !== "#") {
            element.addEventListener("click", function (e) {
                const eventTarget = e.target as HTMLAnchorElement;
                if (eventTarget !== null) {
                    e.preventDefault();
                    if (eventTarget.getAttribute("href") == null) {
                        let target = eventTarget.closest("a")?.getAttribute("href");
                        if (target != null) {
                            scrollIntoView(document.querySelector(target), scrollOptions, function () {
                                history.pushState({}, "", target);
                            });
                        }
                    } else {
                        let target = eventTarget.getAttribute("href");
                        if (target != null) {
                            scrollIntoView(document.querySelector(target), scrollOptions, function () {
                                history.pushState({}, "", target);
                            });
                        }
                    }
                }
            });
        }
    });
}
